module.exports = __webpack_public_path__ + "static/media/day26.workshop.377050fb.md";